import type { SettlementRecord, Worker } from "../types";
import { money, settlementTotals } from "../payrollPresentation";
import { settlementSelectionReady as selectionReady } from "../settlementBankAccount";

/** 고른 기록을 묶을 수 있나 — 받을 돈이 있는 사람은 계좌가 있어야 이체 파일에 실린다. */
export { selectionReady };

/**
 * 2026-10-19 밤 지윤: 고르기 줄은 설명 한 줄만 남는다 — 「20건 · 3.3% 공제 후 1,189,750원」.
 * 묶는 손잡이(검정 「정산 묶음」)와 직접 추가(+)는 제목 줄 오른쪽 끝으로 올라갔다(Skills 의 Add 자리).
 */
export function PlanningPayrollSelectionBar({ selected, workers }: { selected: SettlementRecord[]; workers: Worker[] }) {
  const ready = selectionReady(selected, workers);
  const totals = settlementTotals(selected);
  /* 고른 것이 없으면 줄을 두지 않는다 — 안내 문구(「항목을 선택하면 정산 묶음을…」)는 걷었다, 고르면 그때 건수·금액이 선다(2026-10-21 지윤, 작업자 목록과 같게). */
  if (!selected.length) return null;
  return <div className="payroll-selection-bar">
    <span className="payroll-selection-count" aria-live="polite">
      {selected.length.toLocaleString()}건 · 3.3% 공제 후 {money(totals.payableAmount)}
    </span>
    {!ready && <p role="status">선택한 작업자의 은행 정보를 먼저 확인해 주세요.</p>}
  </div>;
}
